import { createFileRoute, redirect } from '@tanstack/react-router'

// Settings has no dedicated home anymore — its content moved onto the Organization
// page. Land there so the main-nav Settings link keeps working.
export const Route = createFileRoute('/_auth/company/$companyId/settings/')({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: '/company/$companyId/settings/organization',
			params: { companyId: params.companyId },
		})
	},
})
